import lpTokens from './lpTokens'
import { FarmConfig } from './types'

const priceHelperLps: FarmConfig[] = [
  /**
   * These LPs are just used to help with price calculation for MasterChef LPs (farms.ts).
   * This list is added to the MasterChefLps and passed to fetchFarm. The calls to get contract information about the token/quoteToken in the LP are still made.
   * The absense of a PID means the masterchef contract calls are skipped for this farm.
   * Prices are then fetched for all farms (masterchef + priceHelperLps).
   * Before storing to redux, farms without a PID are filtered out.
   */
  {
    pid: null,
    ...lpTokens.snt_wftm_lp,
  },
  {
    pid: null,
    ...lpTokens.magik_wftm_lp,
  },
  {
    pid: null,
    ...lpTokens.ape_wftm_lp,
  },
  {
    pid: null,
    ...lpTokens.ham_wftm_lp,
  },
  {
    pid: null,
    ...lpTokens.ust_ftm_lp,
  },
  {
    pid: null,
    ...lpTokens.luna_ftm_lp,
  },
  {
    pid: null,
    ...lpTokens.ring_usdc_lp,
  },
]

export default priceHelperLps
